export default {
  resource: {
    disabledTip: 'Duration does not meet the requirements of this placement.',
    checkLabel: 'Select all',
    selection: 'Material Selection',
    checkDescribe: '{count} Selected',
  },
  layout: {
    toPage: 'Go to Playturbo to unlock more editing operations.',
    media: 'Network',
    size: 'Placement Size',
    horVideo: 'Landscape',
    squareVideo: 'Square',
    verVideo: 'Portrait',
    broadwise: 'Landscape',
    square: 'Square',
    direction: 'Reels',
    icon: 'Icon',
    facebook: 'Facebook Stories',
    dynamic: 'Feed',
    largeImage: 'Landscape',
    squareImage: 'Square',
    horImage: 'Interstitial',
    screenImage: 'App Open',
    way: 'Adaptation Method',
    fillBlack: 'Fill with Black',
    outCrop: 'Cut off the Excess',
    stretchFill: 'Stretch and Fill',
    customLabel: 'Custom',
    customSize: 'Dimension (required)',
    customDuration: 'Duration (required)',
    inputTips: 'Video dimensions only support even numbers.',
    dimensions: 'Dimension',
    background: 'Background',
    materialFill: 'Filling Method',
    fillEdge: 'Auto Fill',
    cropEdge: 'Auto Crop',
    color: 'Solid Color',
    vague: 'Blur',
    image: 'Images',
    backgroundColor: 'BG Color',
    sellColor: 'Smart Color',
    applyAll: 'Apply to All',
  },
  export: {
    cancel: 'Cancel',
    label: 'Export',
    set: 'Export Settings',
    tips: 'Please select assets first.',
    title: 'Export Assets',
    scale: 'Aspect ratio {ratio}，',
    measurement: 'Dimension {resolution}',
    duration: '，Duration {min}~{max}s',
    content: '{count} assets selected, are you sure to export?',
    success: 'Export task has been added to XMP-Tools - Creative Cropping',
    renderAndBack: 'Export & Return',
    renderAndClose: 'Export & Exit',
  },
}
